import React from "react";
import { cn } from "../../lib/utils";

const STATUS_STYLES = {
  Draft: "bg-slate-100 text-slate-700 border-slate-200",
  "Pending Review": "bg-amber-50 text-amber-800 border-amber-200",
  Active: "bg-emerald-50 text-emerald-800 border-emerald-200",
  Archived: "bg-rose-50 text-rose-700 border-rose-200",
};

export const PolicyStatusBadge = ({ status, className }) => (
  <span data-testid={`policy-status-${status?.toLowerCase().replace(/\s+/g, "-")}`}
    className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-[12.5px] font-semibold border", STATUS_STYLES[status] || STATUS_STYLES.Draft, className)}>
    {status}
  </span>
);

const EXTRACT_STYLES = {
  complete: "text-emerald-700 bg-emerald-50 border-emerald-200",
  partial: "text-amber-800 bg-amber-50 border-amber-200",
  failed: "text-rose-700 bg-rose-50 border-rose-200",
};

export const ExtractionBadge = ({ status, corrected }) => (
  <span data-testid={`extraction-${status}`}
    className={cn("inline-flex items-center px-2 py-0.5 rounded-full text-[12.5px] font-medium border", EXTRACT_STYLES[status] || EXTRACT_STYLES.failed)}>
    {status === "complete" ? (corrected ? "Text corrected" : "Text extracted") : status === "partial" ? "Partial extraction" : "Extraction failed"}
  </span>
);

export const VersionStateBadge = ({ state }) => {
  const map = {
    active: ["Current · Approved", "bg-emerald-600 text-white"],
    pending: ["Working copy · Awaiting approval", "bg-amber-500 text-white"],
    superseded: ["Superseded", "bg-slate-200 text-slate-700"],
  };
  const [label, cls] = map[state] || map.superseded;
  return <span data-testid={`version-state-${state}`} className={cn("px-2 py-0.5 rounded text-[12.5px] font-semibold", cls)}>{label}</span>;
};

export const fmtDate = (iso) => (iso ? new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }) : "—");
export const fmtDateTime = (iso) => (iso ? new Date(iso).toLocaleString(undefined, { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");
export const fmtBytes = (n) => (n > 1024 * 1024 ? `${(n / 1024 / 1024).toFixed(1)} MB` : `${Math.max(1, Math.round((n || 0) / 1024))} KB`);
